import Container from '@mui/material/Container';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import MaterialLink from '@/components/material-link';
import MaterialLinkButton from '@/components/material-link-button';

type Filter = 'rsvp' | 'managed' | 'drafts';

function RsvpEmpty() {
  return (
    <Typography color="text.secondary">
      Events you&apos;ve marked as <strong>Going</strong> or <strong>Interested</strong> will
      appear here so you can easily find them later.
      <br /><br />
      Browse the <MaterialLink href="/calendar">upcoming events</MaterialLink> and RSVP to any
      that catch your eye.
    </Typography>
  );
}

function ManagedEmpty() {
  return (
    <>
      <Typography color="text.secondary">
        Events you&apos;re hosting — either personally or through a group — will appear here.
      </Typography>
      <Typography color="text.secondary" sx={{ mt: 2 }}>
        Ready to lead a ride or post an event? Check out
        the <MaterialLink href="/group-ride-guide">Group Ride Guide</MaterialLink> for tips on
        planning rides.
      </Typography>
      <MaterialLinkButton href="/events/new" variant="outlined" sx={{ mt: 2 }}>
        Create an event
      </MaterialLinkButton>
    </>
  );
}

function DraftsEmpty() {
  return (
    <>
      <Typography color="text.secondary">
        When you create an event and save it without publishing, it will appear here as a draft
        until you&apos;re ready to make it live.
      </Typography>
      <MaterialLinkButton href="/events/new" variant="outlined" sx={{ mt: 2 }}>
        Create an event
      </MaterialLinkButton>
    </>
  );
}

const headings: Record<Filter, string> = {
  rsvp: 'My RSVPs',
  managed: 'My Hosting',
  drafts: 'My Drafts',
};

export default function CalendarEmptyState({ filter }: { filter: Filter }) {
  return (
    <Container maxWidth="md" disableGutters>
      <Typography variant="h2">{headings[filter]}</Typography>
      <Paper variant="outlined" sx={{ p: 3 }}>
        {filter === 'rsvp' && <RsvpEmpty />}
        {filter === 'managed' && <ManagedEmpty />}
        {filter === 'drafts' && <DraftsEmpty />}
      </Paper>
    </Container>
  );
}
